/**
 * A platform as the portal names it: the product a person signs in with or connects
 * (Microsoft 365, Google Workspace, Lark), or email. One place, so the sign-in chooser,
 * People and Integrations never name the same platform two ways.
 */
import type { Platform } from '@lark-automadoc/shared-types'

export function platformName(platform: Platform, t: (key: string) => string): string {
  switch (platform) {
    case 'microsoft': return t('connectionsProviderMicrosoft')
    case 'google': return t('connectionsProviderGoogle')
    case 'lark': return t('platformLark')
    default: return t('platformEmail')
  }
}
